export enum EKwikUIToasterType {
  SUCCESS = "success",
  ERROR = "error",
  WARNING = "warning",
  INFO = "info"
}
export const VKwikUIToasterType = [
  EKwikUIToasterType.SUCCESS,
  EKwikUIToasterType.ERROR,
  EKwikUIToasterType.WARNING,
  EKwikUIToasterType.INFO
] as const;
export type TKwikUIToasterType = (typeof VKwikUIToasterType)[number];

export enum EKwikUIToasterPosition {
  TOP_LEFT = "top-left",
  TOP_CENTER = "top-center",
  TOP_RIGHT = "top-right",
  CENTER_LEFT = "center-left",
  CENTER_CENTER = "center-center",
  CENTER_RIGHT = "center-right",
  BOTTOM_LEFT = "bottom-left",
  BOTTOM_CENTER = "bottom-center",
  BOTTOM_RIGHT = "bottom-right"
}
export const VKwikUIToasterPosition = [
  EKwikUIToasterPosition.TOP_LEFT,
  EKwikUIToasterPosition.TOP_CENTER,
  EKwikUIToasterPosition.TOP_RIGHT,
  EKwikUIToasterPosition.CENTER_LEFT,
  EKwikUIToasterPosition.CENTER_CENTER,
  EKwikUIToasterPosition.CENTER_RIGHT,
  EKwikUIToasterPosition.BOTTOM_LEFT,
  EKwikUIToasterPosition.BOTTOM_CENTER,
  EKwikUIToasterPosition.BOTTOM_RIGHT
] as const;
export type TKwikUIToasterPosition = (typeof VKwikUIToasterPosition)[number];

export enum EKwikUIToasterShape {
  SQUARE = "square",
  ROUNDED = "rounded"
}
export const VKwikUIToasterShape = [
  EKwikUIToasterShape.SQUARE,
  EKwikUIToasterShape.ROUNDED
] as const;
export type TKwikUIToasterShape = (typeof VKwikUIToasterShape)[number];

export enum EKwikUIToasterSize {
  S = "s",
  M = "m",
  L = "l"
}
export const VKwikUIToasterSize = [
  EKwikUIToasterSize.S,
  EKwikUIToasterSize.M,
  EKwikUIToasterSize.L
] as const;
export type TKwikUIToasterSize = (typeof VKwikUIToasterSize)[number];
